module.exports = __webpack_public_path__ + "static/media/015.8df2bc32.jpg";